const ICS_SUCCESS = "ICS_SUCCESS";
const ICS_CLEAR = "ICS_CLEAR";

const initialState = {
    property: [
        {
            id: 1,
            code: "PROP-001",
            name: "Maple Lodge",
            address: "12 Maple Avenue, Bristol, BS1 4TH",
            type: "Residential Care Home",
            cqcNumber: "1-123456789",
            cqcStatus: "Registered - Good",
            totalBeds: 24,
            status: "Active"
        },
        {
            id: 2,
            code: "PROP-002",
            name: "Birchwood House",
            address: "7 Birchwood Lane, Bath, BA2 6PL",
            type: "Supported Living",
            cqcNumber: "1-987654321",
            cqcStatus: "Registered - Outstanding",
            totalBeds: 12,
            status: "Active"
        },
        {
            id: 3,
            code: "PROP-003",
            name: "Sunfield Court",
            address: "34 Sunfield Road, Bristol, BS3 9QR",
            type: "Nursing Home",
            cqcNumber: "1-456789123",
            cqcStatus: "Registered - Requires Improvement",
            totalBeds: 36,
            status: "Archived"
        },
        {
            id: 4,
            code: "PROP-004",
            name: "Elmwood Grange",
            address: "19 Elmwood Drive, Bristol, BS5 2HN",
            type: "Residential Care Home",
            cqcNumber: "1-234567891",
            cqcStatus: "Registered - Good",
            totalBeds: 18,
            status: "Active"
        },
        {
            id: 5,
            code: "PROP-005",
            name: "Rosewood Villa",
            address: "55 Rosewood Close, Weston-super-Mare, BS23 1PT",
            type: "Supported Living",
            cqcNumber: "1-345678912",
            cqcStatus: "Registered - Good",
            totalBeds: 8,
            status: "Active"
        },
        {
            id: 6,
            code: "PROP-006",
            name: "Heathfield Manor",
            address: "3 Heathfield Road, Swindon, SN1 4LW",
            type: "Nursing Home",
            cqcNumber: "1-456891234",
            cqcStatus: "Registered - Outstanding",
            totalBeds: 42,
            status: "Active"
        },
        {
            id: 7,
            code: "PROP-007",
            name: "Oakdale Lodge",
            address: "88 Oakdale Lane, Gloucester, GL1 3BX",
            type: "Residential Care Home",
            cqcNumber: "1-567891234",
            cqcStatus: "Registered - Requires Improvement",
            totalBeds: 20,
            status: "Active"
        },
        {
            id: 8,
            code: "PROP-008",
            name: "Willowbrook House",
            address: "21 Willowbrook Way, Cheltenham, GL50 4DP",
            type: "Supported Living",
            cqcNumber: "1-678912345",
            cqcStatus: "Registered - Good",
            totalBeds: 10,
            status: "Active"
        },
        {
            id: 9,
            code: "PROP-009",
            name: "Ashford Court",
            address: "14 Ashford Street, Bristol, BS7 8RJ",
            type: "Nursing Home",
            cqcNumber: "1-789123456",
            cqcStatus: "Registered - Good",
            totalBeds: 30,
            status: "Active"
        },
        {
            id: 10,
            code: "PROP-010",
            name: "Pinecrest Centre",
            address: "67 Pinecrest Avenue, Bath, BA1 2YQ",
            type: "Day Care Centre",
            cqcNumber: "1-891234567",
            cqcStatus: "Registered - Good",
            totalBeds: 0,
            status: "Active"
        },
        {
            id: 11,
            code: "PROP-011",
            name: "Cedar Ridge",
            address: "9 Cedar Ridge Road, Taunton, TA1 5MN",
            type: "Residential Care Home",
            cqcNumber: "1-912345678",
            cqcStatus: "Registered - Requires Improvement",
            totalBeds: 16,
            status: "Archived"
        },
        {
            id: 12,
            code: "PROP-012",
            name: "Hawthorn Place",
            address: "43 Hawthorn Road, Yeovil, BA20 1EF",
            type: "Supported Living",
            cqcNumber: "1-123498765",
            cqcStatus: "Registered - Outstanding",
            totalBeds: 14,
            status: "Active"
        },
        {
            id: 13,
            code: "PROP-013",
            name: "Ivywood Retreat",
            address: "5 Ivywood Close, Newport, NP20 6GH",
            type: "Nursing Home",
            cqcNumber: "1-234587654",
            cqcStatus: "Registered - Good",
            totalBeds: 28,
            status: "Active"
        }
    ],
    room: [
        {
            id: 1,
            code: "ROOM-001",
            propertyId: 1,
            roomNumber: "101",
            type: "Single En-suite",
            status: "Occupied"
        },
        {
            id: 2,
            code: "ROOM-002",
            propertyId: 1,
            roomNumber: "102",
            type: "Shared Bay (2-bed)",
            status: "Partially Occupied"
        },
        {
            id: 3,
            code: "ROOM-003",
            propertyId: 2,
            roomNumber: "201",
            type: "Single Standard",
            status: "Available"
        },
        {
            id: 4,
            code: "ROOM-004",
            propertyId: 1,
            roomNumber: "103",
            type: "Single En-suite",
            status: "Available"
        },
        {
            id: 5,
            code: "ROOM-005",
            propertyId: 1,
            roomNumber: "104",
            type: "Single Standard",
            status: "Occupied"
        },
        {
            id: 6,
            code: "ROOM-006",
            propertyId: 2,
            roomNumber: "202",
            type: "Single En-suite",
            status: "Occupied"
        },
        {
            id: 7,
            code: "ROOM-007",
            propertyId: 3,
            roomNumber: "301",
            type: "Shared Bay (3-bed)",
            status: "Occupied"
        },
        {
            id: 8,
            code: "ROOM-008",
            propertyId: 3,
            roomNumber: "302",
            type: "Single En-suite",
            status: "Maintenance"
        },
        {
            id: 9,
            code: "ROOM-009",
            propertyId: 4,
            roomNumber: "401",
            type: "Single Standard",
            status: "Available"
        },
        {
            id: 10,
            code: "ROOM-010",
            propertyId: 4,
            roomNumber: "402",
            type: "Single En-suite",
            status: "Occupied"
        },
        {
            id: 11,
            code: "ROOM-011",
            propertyId: 5,
            roomNumber: "501",
            type: "Single Standard",
            status: "Available"
        },
        {
            id: 12,
            code: "ROOM-012",
            propertyId: 6,
            roomNumber: "601",
            type: "Shared Bay (2-bed)",
            status: "Partially Occupied"
        },
        {
            id: 13,
            code: "ROOM-013",
            propertyId: 6,
            roomNumber: "602",
            type: "Single En-suite",
            status: "Occupied"
        }
    ],
    bed: [
        {
            id: 1,
            code: "BED-001",
            roomId: 1,
            bedRef: "Bed A",
            type: "Standard Profiling",
            status: "Occupied"
        },
        {
            id: 2,
            code: "BED-002",
            roomId: 2,
            bedRef: "Bed A",
            type: "Bariatric",
            status: "Occupied"
        },
        {
            id: 3,
            code: "BED-003",
            roomId: 2,
            bedRef: "Bed B",
            type: "Standard Profiling",
            status: "Available"
        },
        {
            id: 4,
            code: "BED-004",
            roomId: 4,
            bedRef: "Bed A",
            type: "Standard Profiling",
            status: "Available"
        },
        {
            id: 5,
            code: "BED-005",
            roomId: 5,
            bedRef: "Bed A",
            type: "Low-profile",
            status: "Occupied"
        },
        {
            id: 6,
            code: "BED-006",
            roomId: 6,
            bedRef: "Bed A",
            type: "Standard Profiling",
            status: "Occupied"
        },
        {
            id: 7,
            code: "BED-007",
            roomId: 7,
            bedRef: "Bed A",
            type: "Bariatric",
            status: "Occupied"
        },
        {
            id: 8,
            code: "BED-008",
            roomId: 7,
            bedRef: "Bed B",
            type: "Standard Profiling",
            status: "Occupied"
        },
        {
            id: 9,
            code: "BED-009",
            roomId: 7,
            bedRef: "Bed C",
            type: "Standard Profiling",
            status: "Available"
        },
        {
            id: 10,
            code: "BED-010",
            roomId: 8,
            bedRef: "Bed A",
            type: "Low-profile",
            status: "Maintenance"
        },
        {
            id: 11,
            code: "BED-011",
            roomId: 9,
            bedRef: "Bed A",
            type: "Standard Profiling",
            status: "Available"
        },
        {
            id: 12,
            code: "BED-012",
            roomId: 10,
            bedRef: "Bed A",
            type: "Bariatric",
            status: "Occupied"
        },
        {
            id: 13,
            code: "BED-013",
            roomId: 12,
            bedRef: "Bed A",
            type: "Standard Profiling",
            status: "Occupied"
        }
    ],
    equipment: [
        {
            id: 1,
            code: "EQ-001",
            itemType: "Bed",
            propertyId: 1,
            roomId: 1,
            bedId: 1,
            name: "Invacare Profiling Bed",
            category: "Moving & Handling",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-01-14",
            lowStock: 1
        },
        {
            id: 2,
            code: "EQ-002",
            itemType: "Property",
            propertyId: 1,
            roomId: null,
            bedId: null,
            name: "Oxford Advance Hoist",
            category: "Moving & Handling",
            quantity: 2,
            condition: "Fair",
            lastInspection: "2024-12-02",
            lowStock: 1
        },
        {
            id: 3,
            code: "EQ-003",
            itemType: "Room",
            propertyId: 2,
            roomId: 3,
            bedId: null,
            name: "Suction Machine",
            category: "Clinical Equipment",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-03-20",
            lowStock: 1
        },
        {
            id: 4,
            code: "EQ-004",
            itemType: "Property",
            propertyId: 2,
            roomId: null,
            bedId: null,
            name: "Shower Trolley",
            category: "Personal Care",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-02-11",
            lowStock: 1
        },
        {
            id: 5,
            code: "EQ-005",
            itemType: "Room",
            propertyId: 1,
            roomId: 2,
            bedId: null,
            name: "Pressure Relief Mattress",
            category: "Tissue Viability",
            quantity: 2,
            condition: "Fair",
            lastInspection: "2025-01-28",
            lowStock: 2
        },
        {
            id: 6,
            code: "EQ-006",
            itemType: "Property",
            propertyId: 3,
            roomId: null,
            bedId: null,
            name: "Stand Aid (Active)",
            category: "Moving & Handling",
            quantity: 3,
            condition: "Poor",
            lastInspection: "2024-11-15",
            lowStock: 2
        },
        {
            id: 7,
            code: "EQ-007",
            itemType: "Bed",
            propertyId: 1,
            roomId: 5,
            bedId: 5,
            name: "Invacare Low-Profile Bed",
            category: "Moving & Handling",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-04-03",
            lowStock: 1
        },
        {
            id: 8,
            code: "EQ-008",
            itemType: "Room",
            propertyId: 4,
            roomId: 9,
            bedId: null,
            name: "Nebuliser",
            category: "Clinical Equipment",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-03-10",
            lowStock: 1
        },
        {
            id: 9,
            code: "EQ-009",
            itemType: "Property",
            propertyId: 4,
            roomId: null,
            bedId: null,
            name: "Electric Wheelchair",
            category: "Mobility",
            quantity: 2,
            condition: "Fair",
            lastInspection: "2025-02-25",
            lowStock: 1
        },
        {
            id: 10,
            code: "EQ-010",
            itemType: "Room",
            propertyId: 6,
            roomId: 12,
            bedId: null,
            name: "Syringe Driver",
            category: "Clinical Equipment",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-04-18",
            lowStock: 1
        },
        {
            id: 11,
            code: "EQ-011",
            itemType: "Property",
            propertyId: 5,
            roomId: null,
            bedId: null,
            name: "Manual Handling Belt",
            category: "Moving & Handling",
            quantity: 5,
            condition: "Good",
            lastInspection: "2025-01-07",
            lowStock: 3
        },
        {
            id: 12,
            code: "EQ-012",
            itemType: "Bed",
            propertyId: 6,
            roomId: 13,
            bedId: 13,
            name: "Arjo Sara Stedy",
            category: "Moving & Handling",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-05-01",
            lowStock: 1
        },
        {
            id: 13,
            code: "EQ-013",
            itemType: "Property",
            propertyId: 3,
            roomId: null,
            bedId: null,
            name: "Defibrillator (AED)",
            category: "Emergency Equipment",
            quantity: 1,
            condition: "Good",
            lastInspection: "2025-03-30",
            lowStock: 1
        }
    ],
    maintenance: [
        {
            id: 1,
            code: "MR-001",
            subjectType: "Property",
            propertyId: 1,
            roomId: null,
            bedId: null,
            equipmentId: null,
            location: "Main entrance - front door",
            description: "Front door closer mechanism faulty",
            priority: "High",
            status: "In Progress",
            contractor: "Secure Fix Ltd",
            raisedDate: "2025-05-10",
            expectedCompletion: "2025-05-17",
            actualCompletion: null
        },
        {
            id: 2,
            code: "MR-002",
            subjectType: "Equipment",
            propertyId: 1,
            roomId: 1,
            bedId: null,
            equipmentId: 2,
            location: "Room 101 - hoist track",
            description: "Hoist motor making grinding noise",
            priority: "Critical",
            status: "Awaiting Parts",
            contractor: "MedEquip Services",
            raisedDate: "2025-04-08",
            expectedCompletion: "2025-04-22",
            actualCompletion: null
        },
        {
            id: 3,
            code: "MR-003",
            subjectType: "Bed",
            propertyId: 1,
            roomId: 1,
            bedId: 1,
            equipmentId: null,
            location: "Room 101 - hoist track",
            description: "Cot side locking pin broken",
            priority: "Critical",
            status: "Completed",
            contractor: "MedEquip Services",
            raisedDate: "2025-04-01",
            expectedCompletion: "2025-04-05",
            actualCompletion: "2025-04-04"
        },
        {
            id: 4,
            code: "MR-004",
            subjectType: "Property",
            propertyId: 2,
            roomId: null,
            bedId: null,
            equipmentId: null,
            location: "Kitchen - extraction fan",
            description: "Extraction fan not functioning, poor ventilation",
            priority: "Medium",
            status: "Scheduled",
            contractor: "Ventair Solutions",
            raisedDate: "2025-05-01",
            expectedCompletion: "2025-05-20",
            actualCompletion: null
        },
        {
            id: 5,
            code: "MR-005",
            subjectType: "Room",
            propertyId: 1,
            roomId: 2,
            bedId: null,
            equipmentId: null,
            location: "Room 102 - ceiling",
            description: "Water stain on ceiling following roof leak",
            priority: "High",
            status: "In Progress",
            contractor: "Roofright Bristol",
            raisedDate: "2025-04-20",
            expectedCompletion: "2025-05-10",
            actualCompletion: null
        },
        {
            id: 6,
            code: "MR-006",
            subjectType: "Equipment",
            propertyId: 3,
            roomId: null,
            bedId: null,
            equipmentId: 6,
            location: "Communal area - stand aid",
            description: "Stand aid battery not holding charge",
            priority: "High",
            status: "Awaiting Parts",
            contractor: "MedEquip Services",
            raisedDate: "2025-03-15",
            expectedCompletion: "2025-03-28",
            actualCompletion: null
        },
        {
            id: 7,
            code: "MR-007",
            subjectType: "Property",
            propertyId: 4,
            roomId: null,
            bedId: null,
            equipmentId: null,
            location: "Car park - external lighting",
            description: "Two security lights have failed",
            priority: "Low",
            status: "Scheduled",
            contractor: "Brightlight Electrical",
            raisedDate: "2025-05-05",
            expectedCompletion: "2025-05-25",
            actualCompletion: null
        },
        {
            id: 8,
            code: "MR-008",
            subjectType: "Bed",
            propertyId: 1,
            roomId: 5,
            bedId: 5,
            equipmentId: null,
            location: "Room 104 - bed frame",
            description: "Height adjustment motor unresponsive",
            priority: "Critical",
            status: "Completed",
            contractor: "MedEquip Services",
            raisedDate: "2025-04-12",
            expectedCompletion: "2025-04-15",
            actualCompletion: "2025-04-14"
        },
        {
            id: 9,
            code: "MR-009",
            subjectType: "Room",
            propertyId: 6,
            roomId: 13,
            bedId: null,
            equipmentId: null,
            location: "Room 602 - en-suite",
            description: "Hot water not reaching room en-suite",
            priority: "High",
            status: "In Progress",
            contractor: "Aquaflow Plumbing",
            raisedDate: "2025-05-08",
            expectedCompletion: "2025-05-16",
            actualCompletion: null
        },
        {
            id: 10,
            code: "MR-010",
            subjectType: "Equipment",
            propertyId: 4,
            roomId: 9,
            bedId: null,
            equipmentId: 8,
            location: "Room 401 - nebuliser",
            description: "Nebuliser compressor intermittently cutting out",
            priority: "Medium",
            status: "Completed",
            contractor: "ClinEquip Ltd",
            raisedDate: "2025-03-22",
            expectedCompletion: "2025-03-29",
            actualCompletion: "2025-03-28"
        },
        {
            id: 11,
            code: "MR-011",
            subjectType: "Property",
            propertyId: 5,
            roomId: null,
            bedId: null,
            equipmentId: null,
            location: "Lounge - ceiling",
            description: "Smoke alarm sensor faulty, false alarms triggered",
            priority: "Critical",
            status: "Completed",
            contractor: "SafeGuard Fire Systems",
            raisedDate: "2025-02-28",
            expectedCompletion: "2025-03-03",
            actualCompletion: "2025-03-02"
        },
        {
            id: 12,
            code: "MR-012",
            subjectType: "Room",
            propertyId: 3,
            roomId: 8,
            bedId: null,
            equipmentId: null,
            location: "Room 302 - window",
            description: "Window lock broken, room not secure",
            priority: "High",
            status: "Completed",
            contractor: "Secure Fix Ltd",
            raisedDate: "2025-04-25",
            expectedCompletion: "2025-04-28",
            actualCompletion: "2025-04-27"
        },
        {
            id: 13,
            code: "MR-013",
            subjectType: "Equipment",
            propertyId: 2,
            roomId: null,
            bedId: null,
            equipmentId: 4,
            location: "Bathroom - shower trolley",
            description: "Shower trolley wheel caster cracked",
            priority: "Medium",
            status: "Scheduled",
            contractor: "MedEquip Services",
            raisedDate: "2025-05-11",
            expectedCompletion: "2025-05-24",
            actualCompletion: null
        }
    ]
};

const ICSdataReducer = (state = initialState, action) => {
    switch (action.type) {
        case ICS_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case ICS_CLEAR:
            return { ...initialState };
        default:
            return state;
    }
};

// Action creators
const setICSData = (payload) => ({ type: ICS_SUCCESS, payload });
const clearICSData = () => ({ type: ICS_CLEAR });

export { setICSData, clearICSData, ICSdataReducer };
